/**
 * Full-page view when the current user's account has been soft-deleted.
 * Shown from Layout when profile.status === 'soft_deleted'. User can only sign out.
 */
interface DeletedAccountPageProps {
  signOut: () => Promise<void>
}

export default function DeletedAccountPage({ signOut }: DeletedAccountPageProps) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)' }}
      role="alert"
      aria-live="assertive"
    >
      <h1 className="text-2xl font-bold mb-4 text-center">
        Account deleted
      </h1>
      <p className="text-center mb-6 max-w-md" style={{ color: 'var(--text-secondary)' }}>
        Your account has been deleted. You cannot use the platform. If you believe this is an error, contact{' '}
        <a href="mailto:support@insideaccess.org" className="underline" style={{ color: 'var(--text-primary)' }}>
          support@insideaccess.org
        </a>.
      </p>
      <button
        type="button"
        onClick={() => signOut()}
        className="px-6 py-3 font-semibold rounded border-2"
        style={{
          backgroundColor: 'var(--bg-interactive)',
          color: 'var(--text-inverse)',
          borderColor: 'var(--bg-interactive)',
        }}
      >
        Sign out
      </button>
    </div>
  )
}
